import clsx from "clsx";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Box } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import { lighten } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  diffBadge: {
    display: "inline-flex",
    alignItems: "center",
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(0.3),
    fontSize: 14,
    fontWeight: 600,
    whiteSpace: "nowrap",
  },

  diffPositive: {
    color: theme.palette.progress.green,
  },

  diffNegative: {
    color: lighten(theme.palette.error.main, 0.2),
  },
}));

type DiffBadgeProps = {
  value?: number;
  show?: boolean;
};

export const DiffBadge: React.FC<DiffBadgeProps> = ({ value, show = true }) => {
  const s = useStyles();

  if (!show || !value || value === 0 || Number.isNaN(value)) return null;

  const isPositive = value > 0;

  return (
    <Box
      component="span"
      className={clsx(
        s.diffBadge,
        isPositive ? s.diffPositive : s.diffNegative,
      )}
    >
      {isPositive ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      {Math.abs(value)}
    </Box>
  );
};
